import { Component, OnInit } from '@angular/core';
import { LoansService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-breaking-active-loan',
  templateUrl: './breaking-active-loan.component.html',
  styleUrls: ['./breaking-active-loan.component.css']
})
export class BreakingActiveLoanComponent implements OnInit {
  currentUser: any;
  data = null;
  loading = false;

  constructor(
    public loansService: LoansService,
    public storageService: StorageService
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.loansService.getPortfoliActionsReports(this.currentUser.token).subscribe(({ status, data }: any) => {
      if (status) this.data = data;
      this.loading = false;
    })
  }
}
